module.exports = __webpack_public_path__ + "odinstatic/media/error.65d70633.svg";